const enterEmailStep = {
  heroTitle: "ADOBE DIGITAL EXPERIENCE PARTNER PROGRAM",
  heroThanks:
    "Thanks for your interest in the Adobe Digital Experience Partner Program.",
  heroGetStarted: "To get started, please enter your corporate email address.",
  cardTitle: "Enter your email address",
  cardHint:
    "Use a corporate email address (Adobe ID) , such as name@company.com. Group email or distribution list addresses are not permitted.",
  fieldLabel: "Company assigned email address",
  buttonLabel: "Check email",
  errors: {
    required: "This field is required.",
    pattern: "Invalid email",
    invalidEmail:
      "Please enter a personal (not an alias) corporate company email address.",
  },
} as const;

export type EnterEmailStepContent = typeof enterEmailStep;
export default enterEmailStep;
